var path = '/formViewer/structure/row/row.tpl.html';
var html = "<div class=\"formRowContainer\"\n     ng-class=\"{\n        removeIndent: $ctrl.shouldRemoveIndent($ctrl.row)\n     }\"\n     ui-scroll-into-view=\"{{ ::!$ctrl.containsSupplementalForm }}\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;